import { TweenMax, TimelineLite, Power2, Elastic, CSSPlugin } from "gsap";
import ScrollMagic from 'ScrollMagic';

const imgZoomController = new ScrollMagic.Controller();
let imgTrigger = '.img-wrapper';


$(imgTrigger).each(function(){
	let target = $(this).find('img');
	let imgScene = new ScrollMagic.Scene({
		triggerElement: this,
		triggerHook : 1,
	})
	.addTo(imgZoomController)
	
	imgScene.on("enter", function(){
		target.addClass('zoom-out')
	})
	imgScene.on("leave", function(){
		target.removeClass('zoom-out')
	})
})